module.exports = __webpack_public_path__ + "images/mdj/members/resume/quick_resume/step3_bg_right-7419e724423557b2dc41442db6eb6e94.png";